import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import Masonry from 'react-masonry-component';
import CategoryListItemMasonry from '../category-list-item-masonry';
import styles from './category-list-masonry.scss';

const MASONRY_OPTIONS = {
  transitionDuration: 0,
  fitWidth: true,
  gutter: 30,
};

const CategoryListMasonry = ({ className, categories }) =>
  <div className={classNames(styles.container, className)}>
    <Masonry className={styles.masonry} options={MASONRY_OPTIONS}>
      {categories.map(category =>
        <div key={category._id} className={styles.listItem}>
          <CategoryListItemMasonry category={category}/>
        </div>
      )}
    </Masonry>
  </div>;

CategoryListMasonry.propTypes = {
  className: PropTypes.string,
  categories: PropTypes.array.isRequired,
};

export default CategoryListMasonry;



// WEBPACK FOOTER //
// ./app/components/category-list-masonry/category-list-masonry.js